"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuContentMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _typographyMixin = require("../typographyMixin");
/** @class MenuContentMixin */
/**
 * Standalone styles for menu text content.
 *
 * @example
 * import { MenuContentMixin } from "@zillow/constellation";
 *
 * const Component = styled.p`
 *     ${MenuContentMixin}
 * `;
 *
 * <Component>Menu content</Component>
 *
 * @method
 * @param props {object}
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */
var MenuContentMixin = function MenuContentMixin(props) {
  return (0, _styledToken.default)({
    fontType: 'MenuContent.fontType',
    horizontalSpacing: 'MenuContent.horizontalSpacing',
    verticalSpacing: 'MenuContent.verticalSpacing',
    margin: 'MenuContent.margin'
  }, function (_ref) {
    var fontType = _ref.fontType,
      horizontalSpacing = _ref.horizontalSpacing,
      verticalSpacing = _ref.verticalSpacing,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin;
    return (0, _styledComponents.css)(["", " margin:", "px;padding:", "px ", "px;"], (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), margin, verticalSpacing, horizontalSpacing);
  })(props);
};
exports.MenuContentMixin = MenuContentMixin;